;(function () {
  lightbox.option({
    disableScrolling: true,
  })
})()
